import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Article from './Article';
import GoogleAuthProvider from './auth/GoogleAuthProvider';
import LoginGate from './auth/LoginGate';
import AdminPage from './admin/AdminPage';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/blogs/:slug" element={<Article />} />
        {/* Legacy path from before the section was renamed to Blogs, kept so
            previously shared links keep working. */}
        <Route path="/reflections/:slug" element={<Article />} />
        <Route
          path="/admin/*"
          element={
            <GoogleAuthProvider>
              <LoginGate>
                <AdminPage />
              </LoginGate>
            </GoogleAuthProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
